import { combineReducers } from "redux";
import GlobalReducers from "./reducers/GlobalReducers";
import MainReducers from "./reducers/MainReducers";

export default combineReducers({
  GlobalResponse: GlobalReducers,
  MainResponse: MainReducers,
});
